// src/App.js
import MainTemplate from "components/templates/MainTemplate/MainTemplate";
import React, { useState, useEffect, useRef } from "react";
import Step1 from "views/Step1";
import Step2 from "views/Step2";
import Step3 from "views/Step3";
import Step4 from "views/Step4";

function App() {
  const [selectedChallenges, setSelectedChallenges] = useState([]);
  const [filledFields, setFilledFields] = useState({});
  const [step, setStep] = useState(1);
  const [price, setPrice] = useState("");
  const [summary, setSummary] = useState([]);
  const [validationError, setValidationError] = useState({});
  const [priceValidationError, setPriceValidationError] = useState({});
  const [lang, setLang] = useState("pl-PL");
  useEffect(() => {
    // Get the lang attribute from the HTML document
    const langAttribute = document.documentElement.lang;
    if (langAttribute === "pl-PL") {
      setLang("pl");
    } else if (langAttribute === "en-US") {
      setLang("en");
    } else {
      setLang("pl");
    }
  }, []);

  const handleBackStep = (step) => {
    setStep(step - 1);
  };
  const handleStep1Next = (challenges) => {
    setSelectedChallenges(challenges);
    setStep(2);
  };
  const handleStep2Next = (fields, summary) => {
    setFilledFields(fields);
    setSummary(summary);
    setStep(3);
  };
  const handleStep3Next = (value) => {
    setPrice(value);
    setStep(4);
  };
  const appRef = useRef(null);

  const scrollToTopOfApp = () => {
    if (appRef.current) {
      appRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
  return (
    <div className="App" ref={appRef}>
      <MainTemplate lang={lang} step={step} setStep={setStep}>
        {step === 1 && (
          <Step1
            lang={lang}
            selectedChallenges={selectedChallenges}
            setSelectedChallenges={setSelectedChallenges}
            onSelectChallenges={handleStep1Next}
          />
        )}
        {step === 2 && (
          <Step2
            lang={lang}
            selectedChallenges={selectedChallenges}
            inputValues={filledFields}
            onHandleNextStep={handleStep2Next}
            onFilledFields={setFilledFields}
            step={step}
            onHandleBackStep={handleBackStep}
            validationError={validationError}
            setValidationError={setValidationError}
          />
        )}
        {step === 3 && (
          <Step3
            lang={lang}
            priceValue={price}
            onHandleNextStep={handleStep3Next}
            onHandleBackStep={handleBackStep}
            step={step}
            summary={summary}
            priceValidationError={priceValidationError}
            setPriceValidationError={setPriceValidationError}
          />
        )}
        {step === 4 && (
          <Step4
            lang={lang}
            priceValue={price}
            summary={summary}
            filledFields={filledFields}
            onHandleBackStep={handleBackStep}
            step={step}
            setStep={setStep}
            setFilledFields={setFilledFields}
            setPrice={setPrice}
            setSummary={setSummary}
            setSelectedChallenges={setSelectedChallenges}
            scrollToTopOfApp={scrollToTopOfApp}
          />
        )}
      </MainTemplate>
    </div>
  );
}

export default App;
